import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { getAgencyOverlayWorkspace, legalObligationOverlayQueryKeys } from '../../lib/legalObligationOverlays';

/**
 * 현장 목록의 「우리 기관 서식」 입구 — **대행 관리하는 현장이 있는 조직에만** 보인다(판정은 서버 `isAgency` ·
 * 술어 정본은 서버 `managingAgenciesOf` — 그것을 where로 옮긴 것이 `AgencyObligationOverlayService`의 `countAgencySites`다.
 * 2026-10-31 재개정 이후 「현재 대행 역할 링크」가 기준이다). 수검업체(대행을 받는 쪽)에는 뜨지 않는다.
 * 실패·로딩 중에는 아무것도 그리지 않는다(이 입구가 현장 목록을 막지 않게).
 * ⚠️ 호출부가 `obligation.view`로 감싼다 — 그 API가 그 키를 요구한다.
 */
export default function AgencyOverlayEntryLink({ companyId }: { companyId: string }) {
  const { data } = useQuery({
    queryKey: legalObligationOverlayQueryKeys.workspace(companyId),
    queryFn: () => getAgencyOverlayWorkspace(companyId),
    retry: false,
  });
  if (!data?.isAgency) return null;
  return (
    <Link
      to="/legal-documents/agency-overlays"
      className="inline-flex items-center rounded-[10px] border border-ink-200 px-3 py-1.5 text-sm font-bold text-ink-700 hover:bg-surface-hover"
    >
      우리 기관 서식
      {data.overlays.some((o) => o.isActive) && (
        <span className="ml-1.5 text-xs font-medium text-ink-500">
          변형 {data.overlays.filter((o) => o.isActive).length}
        </span>
      )}
    </Link>
  );
}
